import { StatusOption } from '../../utils'

export enum CseStatusEnum {
  NA = 'NA',
  PRESENT = 'PRESENT',
  PENDING = 'PENDING',
  VALIDATED = 'VALIDATED',
  REJECTED = 'REJECTED'
}

export const cseStatusEnumMapping: Record<CseStatusEnum, StatusOption> = {
  [CseStatusEnum.NA]: { label: 'N/A', variant: 'grey' },
  [CseStatusEnum.PRESENT]: { label: 'Demande à envoyer au CSE', variant: 'warning' },
  [CseStatusEnum.PENDING]: { label: 'En attente acceptation du CSE', variant: 'warning' },
  [CseStatusEnum.VALIDATED]: { label: 'Accepté', variant: 'success' },
  [CseStatusEnum.REJECTED]: { label: 'Rejeté', variant: 'danger' }
}
